'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var Identity = require('./identity');

var IdentityProvider = require('./identity-provider-interface.js');

var OrbitDBIdentityProvider = require('./orbit-db-identity-provider');

var Keystore = require('orbit-db-keystore');

var LRU = require('lru');

var path = require('path');

var defaultType = 'orbitdb';
var identityKeysPath = path.join('./orbitdb', 'identity', 'identitykeys');
var supportedTypes = {
  orbitdb: OrbitDBIdentityProvider
};

var getHandlerFor = function getHandlerFor(type) {
  if (!Identities.isSupported(type)) {
    throw new Error("IdentityProvider type '".concat(type, "' is not supported"));
  }

  return supportedTypes[type];
};

var Identities = /*#__PURE__*/function () {
  function Identities(options) {
    _classCallCheck(this, Identities);

    this._keystore = options.keystore;
    this._signingKeystore = options.signingKeystore || this._keystore;
    this._knownIdentities = options.cache || new LRU(options.cacheSize || 100);
  }

  _createClass(Identities, [{
    key: "keystore",
    get: function get() {
      return this._keystore;
    }
  }, {
    key: "signingKeystore",
    get: function get() {
      return this._signingKeystore;
    }
  }, {
    key: "sign",
    value: function () {
      var _sign = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(identity, data) {
        var signingKey, sig;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.keystore.getKey(identity.id);

              case 2:
                signingKey = _context.sent;

                if (signingKey) {
                  _context.next = 5;
                  break;
                }

                throw new Error("Private signing key not found from Keystore");

              case 5:
                _context.next = 7;
                return this.keystore.sign(signingKey, data);

              case 7:
                sig = _context.sent;
                return _context.abrupt("return", sig);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function sign(_x, _x2) {
        return _sign.apply(this, arguments);
      }

      return sign;
    }()
  }, {
    key: "verify",
    value: function () {
      var _verify = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(signature, publicKey, data) {
        var verifier,
            _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                verifier = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : 'v1';
                return _context2.abrupt("return", this.keystore.verify(signature, publicKey, data, verifier));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function verify(_x3, _x4, _x5) {
        return _verify.apply(this, arguments);
      }

      return verify;
    }()
  }, {
    key: "createIdentity",
    value: function () {
      var _createIdentity = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var options,
            keystore,
            type,
            identityProvider,
            id,
            _yield$this$signId,
            publicKey,
            idSignature,
            pubKeyIdSignature,
            _args3 = arguments;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                options = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
                keystore = options.keystore || this.keystore;
                type = options.type || defaultType;
                identityProvider = type === defaultType ? new OrbitDBIdentityProvider(options.signingKeystore || keystore) : new (getHandlerFor(type))(options);
                _context3.next = 6;
                return identityProvider.getId(options);

              case 6:
                id = _context3.sent;

                if (!options.migrate) {
                  _context3.next = 10;
                  break;
                }

                _context3.next = 10;
                return options.migrate({
                  targetStore: keystore._store,
                  targetId: id
                });

              case 10:
                _context3.next = 12;
                return this.signId(id);

              case 12:
                _yield$this$signId = _context3.sent;
                publicKey = _yield$this$signId.publicKey;
                idSignature = _yield$this$signId.idSignature;
                _context3.next = 17;
                return identityProvider.signIdentity(publicKey + idSignature, options);

              case 17:
                pubKeyIdSignature = _context3.sent;
                return _context3.abrupt("return", new Identity(id, publicKey, idSignature, pubKeyIdSignature, type, this));

              case 19:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function createIdentity() {
        return _createIdentity.apply(this, arguments);
      }

      return createIdentity;
    }()
  }, {
    key: "signId",
    value: function () {
      var _signId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(id) {
        var keystore, key, publicKey, idSignature;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                keystore = this.keystore;
                _context4.next = 3;
                return keystore.getKey(id);

              case 3:
                _context4.t0 = _context4.sent;

                if (_context4.t0) {
                  _context4.next = 8;
                  break;
                }

                _context4.next = 7;
                return keystore.createKey(id);

              case 7:
                _context4.t0 = _context4.sent;

              case 8:
                key = _context4.t0;
                publicKey = keystore.getPublic(key);
                _context4.next = 12;
                return keystore.sign(key, id);

              case 12:
                idSignature = _context4.sent;
                return _context4.abrupt("return", {
                  publicKey: publicKey,
                  idSignature: idSignature
                });

              case 14:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function signId(_x6) {
        return _signId.apply(this, arguments);
      }

      return signId;
    }()
  }, {
    key: "verifyIdentity",
    value: function () {
      var _verifyIdentity = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(identity) {
        var knownID, verifyIdSig, IdentityProvider, verified;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (Identity.isIdentity(identity)) {
                  _context5.next = 2;
                  break;
                }

                return _context5.abrupt("return", false);

              case 2:
                knownID = this._knownIdentities.get(identity.signatures.id);

                if (!knownID) {
                  _context5.next = 5;
                  break;
                }

                return _context5.abrupt("return", identity.id === knownID.id && identity.publicKey === knownID.publicKey && identity.signatures.id === knownID.signatures.id && identity.signatures.publicKey === knownID.signatures.publicKey);

              case 5:
                _context5.next = 7;
                return this.keystore.verify(identity.signatures.id, identity.publicKey, identity.id);

              case 7:
                verifyIdSig = _context5.sent;

                if (verifyIdSig) {
                  _context5.next = 10;
                  break;
                }

                return _context5.abrupt("return", false);

              case 10:
                IdentityProvider = getHandlerFor(identity.type);
                _context5.next = 13;
                return IdentityProvider.verifyIdentity(identity);

              case 13:
                verified = _context5.sent;

                if (verified) {
                  this._knownIdentities.set(identity.signatures.id, Identity.toJSON(identity));
                }

                return _context5.abrupt("return", verified);

              case 16:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function verifyIdentity(_x7) {
        return _verifyIdentity.apply(this, arguments);
      }

      return verifyIdentity;
    }()
  }], [{
    key: "IdentityProvider",
    get: function get() {
      return IdentityProvider;
    }
  }, {
    key: "verifyIdentity",
    value: function () {
      var _verifyIdentity2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(identity) {
        var verifyIdSig, IdentityProvider;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (Identity.isIdentity(identity)) {
                  _context6.next = 2;
                  break;
                }

                return _context6.abrupt("return", false);

              case 2:
                _context6.next = 4;
                return Keystore.verify(identity.signatures.id, identity.publicKey, identity.id);

              case 4:
                verifyIdSig = _context6.sent;

                if (verifyIdSig) {
                  _context6.next = 7;
                  break;
                }

                return _context6.abrupt("return", false);

              case 7:
                IdentityProvider = getHandlerFor(identity.type);
                return _context6.abrupt("return", IdentityProvider.verifyIdentity(identity));

              case 9:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function verifyIdentity(_x8) {
        return _verifyIdentity2.apply(this, arguments);
      }

      return verifyIdentity;
    }()
  }, {
    key: "createIdentity",
    value: function () {
      var _createIdentity2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var options,
            identities,
            _args7 = arguments;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                options = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : {};

                if (!options.keystore) {
                  options.keystore = new Keystore(options.identityKeysPath || identityKeysPath);
                }

                if (!options.signingKeystore) {
                  if (options.signingKeysPath) {
                    options.signingKeystore = new Keystore(options.signingKeysPath);
                  } else {
                    options.signingKeystore = options.keystore;
                  }
                }

                options = Object.assign({}, {
                  type: defaultType
                }, options);
                identities = new Identities(options);
                return _context7.abrupt("return", identities.createIdentity(options));

              case 6:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function createIdentity() {
        return _createIdentity2.apply(this, arguments);
      }

      return createIdentity;
    }()
  }, {
    key: "isSupported",
    value: function isSupported(type) {
      return Object.keys(supportedTypes).includes(type);
    }
  }, {
    key: "addIdentityProvider",
    value: function addIdentityProvider(IdentityProvider) {
      if (!IdentityProvider) {
        throw new Error('IdentityProvider class needs to be given as an option');
      }

      if (!IdentityProvider.type || typeof IdentityProvider.type !== 'string') {
        throw new Error('Given IdentityProvider class needs to implement: static get type() { /* return a string */}.');
      }

      supportedTypes[IdentityProvider.type] = IdentityProvider;
    }
  }, {
    key: "removeIdentityProvider",
    value: function removeIdentityProvider(type) {
      delete supportedTypes[type];
    }
  }]);

  return Identities;
}();

module.exports = Identities;